import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Tooltip, Modal, ModalBody, ModalHeader, ModalFooter, Button, FormGroup, Label, Col, Input, InputGroup, InputGroupAddon, Form } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import ProviderNavbar from './ProviderNavbar';
import Message from '../general/Message';
import UserNotApproved from './UserNotApproved';

const SelectProviderSubscriptionPlan = props => {

    // states
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState(null);
    // const [activeSubscriptionPlan, setActiveSubscriptionPlan] = useState(null);
    // const [isSubscriptionActive, setIsSubscriptionActive] = useState(null);


    // contexts
    const { theme, colors } = useContext(ThemeContext);
    const { user, userApprovalStatus } = useContext(AuthContext);

    // utility functions


    // useEffects
    useEffect(() => {
        ProviderService.getProviderSubscriptionPlans()
            .then(plans => {
                setSubscriptionPlans(plans.providerSubscriptionPlans)
                // console.log(plans)
            })
            .catch(err => {
                console.log(err);
            })
    }, []);


    // handle functions
    const handlePlanSelect = e => {
        // console.log(selectedSubscriptionPlan._id)
        if (selectedSubscriptionPlan._id) {
            try {
                props.history.push({
                    pathname: "/counsellor/makesubscriptionpayment",
                    state: {
                        selectedSubscriptionPlan: selectedSubscriptionPlan
                    }
                });
            } catch (err) {
                console.log(err);
            }
        }
    }


    // function's return
    return (
        <div>
            <ProviderNavbar history={props.history} />

            {
                userApprovalStatus ?

                    <div className='text-center m-5'>

                        <div className='mb-5'>
                            <h1 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Counsellor Subscriptions - Plans &amp; Pricings</h1>
                            <h2 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Select the Tier that suits your needs</h2>
                        </div>


                        {
                            subscriptionPlans.map((item, index) => (
                                <div key={index} className="d-inline-block col-8 col-sm-8 col-md-3 text-center px-2 py-3 m-3" style={selectedSubscriptionPlan == item ? theme.selectedSlotCard : theme.slotCard} onClick={() => setSelectedSubscriptionPlan(item)}>
                                    <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                                    <p>{`₹${item.amount / 100}`}</p>
                                    <div>
                                        <p><i style={{ color: colors.primary }} className='fas fa-check'></i> Upto {item.serviceDetails.totalSessionBookingsAllowed} Session Bookings</p>
                                        <p><i style={{ color: colors.primary }} className='fas fa-check'></i> Upto {item.serviceDetails.clientLimit} Clients</p>
                                        {item.serviceDetails.modeOfServices.call ? <p><i style={{ color: colors.primary }} className='fas fa-check'></i> {item.serviceDetails.modeOfServices.call} Call</p> : null}
                                        {item.serviceDetails.modeOfServices.chat ? <p><i style={{ color: colors.primary }} className='fas fa-check'></i> {item.serviceDetails.modeOfServices.chat} Chat</p> : null}
                                        {item.serviceDetails.modeOfServices.video ? <p><i style={{ color: colors.primary }} className='fas fa-check'></i> {item.serviceDetails.modeOfServices.video} Video</p> : null}
                                        {item.serviceDetails.modeOfServices.inPerson ? <p><i style={{ color: colors.primary }} className='fas fa-check'></i> {item.serviceDetails.modeOfServices.inPerson} In Person</p> : null}
                                        {item.serviceDetails.createClientSubscriptionPlans ? <p><i style={{ color: colors.primary }} className='fas fa-check'></i> {item.serviceDetails.createClientSubscriptionPlans} Create Client Subscription Plans</p> : null}

                                    </div>
                                </div>
                            ))
                        }


                        <div>
                            <button className="btn mx-auto mt-4" id="paymentBtn" type="button" style={theme.button} onClick={() => handlePlanSelect()}>
                                Continue Payment
                            </button>
                        </div>


                    </div>
                    :
                    <UserNotApproved />
            }

        </div>
    )
}

export default SelectProviderSubscriptionPlan;